import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import TutorSidebar from '../../../../TutorSidebar/TutorSidebar'
import { getTutorMyCourseOneToOneListData, getTutorMyCourseBatchListData, getTutorMyCourseGroupListData } from '../../../../../../Redux/action/TutorAction'
import { Link, useNavigate } from 'react-router-dom';
import { useFormik } from "formik";
import { toast } from 'react-hot-toast';
import * as Yup from "yup";
import axios from 'axios';
import HourglassLoader from '../../../../../../Common/HourglassLoader';
import moment from "moment-timezone";
import { jwtDecode } from "jwt-decode";
const host = process.env.REACT_APP_API_SERVER
const TutorAddObjectiveAssessment = () => {
    const authToken = localStorage.getItem('tutor-token');
    const decoded = jwtDecode(authToken);

    const userTimeZone = decoded?.user?.time_zone
    const todayLocal = moment().tz(userTimeZone).format("YYYY-MM-DD"); // Convert to local timezone


    const dispatch = useDispatch();
    const navigate = useNavigate();
    useEffect(() => {
        dispatch(getTutorMyCourseOneToOneListData());
        dispatch(getTutorMyCourseGroupListData())

    }, []);

    const {
        loadingTutorMyCourseOneListApi,
        TutorMyCourseOneListApiData,
        TutorMyCourseOneListApiError,


        loadingTutorMyCourseGroupBatchListApi,
        TutorMyCourseGroupBatchListApiData,
        TutorMyCourseGroupBatchListApiError,


        loadingTutorMyCourseGroupListApi,
        TutorMyCourseGroupListApiData,
        TutorMyCourseGroupListApiError,

    } = useSelector(state => state?.TutorReducer);


    const oneformik = useFormik({
        initialValues: {
            assesment_type: '0',
            question_type: '0',
            course_id: "",
            assesment_name: "",
            no_of_question: "",
            total_marks: "",
            duration: "",
            assesment_date: "",
            submit_date: "",
            batch_id: '0',
        },
        validationSchema: Yup.object().shape({

            course_id: Yup.string().required("Course is required."),
            assesment_name: Yup.string().required("Assessment name is required"),
            no_of_question: Yup.string()
                .required("No. of question is required.")
                .matches(/^\d+$/, "No. of question must be a valid number.")
                .test("min", "No. of question cannot be less than 1.", value => {
                    return parseInt(value, 10) >= 1;
                }),
            total_marks: Yup.string()
                .required("Total marks is required.")
                .matches(/^\d+$/, "Total marks must be a valid number.")
                .test("min", "Total marks cannot be less than 1.", value => {
                    return parseInt(value, 10) >= 1;
                }),
            duration: Yup.string()
                .required("Duration is required.")
                .matches(/^\d+$/, "Duration must be a valid number.")
                .test("min", "Duration cannot be less than 1.", value => {
                    return parseInt(value, 10) >= 1;
                }),
            // no_of_question: Yup.string().required("No. of question is required."),
            // total_marks: Yup.string().required("Total marks is required"),
            // duration: Yup.string().required("Durtion is required."),
            assesment_date: Yup.date().required("Start date is required"),

            submit_date: Yup.date()
                .required("End date is required")
                .min(Yup.ref("assesment_date"), "End date must be after start date"),

        }),
        onSubmit: async (values, { setSubmitting, resetForm }) => {
            try {

                setSubmitting(true);
                const config = {
                    headers: {
                        // "Content-Type": "application/json",
                        "x-auth-token": localStorage.getItem('tutor-token'),
                    },
                }
                const response = await axios.post(`${host}/api/tutor/create-assessment`, values, config);

                if (response.status === 200) {
                    setSubmitting(false);
                    toast.success("Assessment Created Successfully");
                    resetForm();

                    localStorage.setItem('data', response.data.data)
                    navigate(`/tutor/add-objective-questions`, { state: { data: response.data.data } });
                } else {
                    setSubmitting(false);
                    toast.error(response.data.message);
                }
            } catch (error) {
                setSubmitting(false);
                console.error("Error:", error);
                toast.error('Error submitting form. Please try again.');
            }
        }

    })


    const groupformik = useFormik({
        initialValues: {
            batch_id: '',
            assesment_type: '1',
            question_type: '0',
            course_id: "",
            assesment_name: "",
            no_of_question: "",
            total_marks: "",
            duration: "",
            assesment_date: "",
            submit_date: "",
        },
        validationSchema: Yup.object().shape({
            batch_id: Yup.string().required("Batch is required."),
            course_id: Yup.string().required("Course is required."),
            assesment_name: Yup.string().required("Assessment name is required"),
            no_of_question: Yup.string()
                .required("No. of question is required.")
                .matches(/^\d+$/, "No. of question must be a valid number.")
                .test("min", "No. of question cannot be less than 1.", value => {
                    return parseInt(value, 10) >= 1;
                }),
            total_marks: Yup.string()
                .required("Total marks is required.")
                .matches(/^\d+$/, "Total marks must be a valid number.")
                .test("min", "Total marks cannot be less than 1.", value => {
                    return parseInt(value, 10) >= 1;
                }),
            duration: Yup.string()
                .required("Duration is required.")
                .matches(/^\d+$/, "Duration must be a valid number.")
                .test("min", "Duration cannot be less than 1.", value => {
                    return parseInt(value, 10) >= 1;
                }),
            // no_of_question: Yup.string().required("No. of question is required."),
            // total_marks: Yup.string().required("Total marks is required"),
            // duration: Yup.string().required("Durtion is required."),
            assesment_date: Yup.string().required("Start date is required"),
            submit_date: Yup.string().required("End Date is required."),


        }),
        onSubmit: async (values, { setSubmitting, resetForm }) => {
            try {

                setSubmitting(true);
                const config = {
                    headers: {
                        // "Content-Type": "application/json",
                        "x-auth-token": localStorage.getItem('tutor-token'),
                    },
                }
                const response = await axios.post(`${host}/api/tutor/create-assessment`, values, config);

                if (response.status === 200) {
                    setSubmitting(false);
                    toast.success("Assessment Created Successfully");
                    resetForm();
                    localStorage.removeItem('data')

                    navigate(`/tutor/add-objective-questions`, { state: { data: response.data.data } });
                } else {
                    setSubmitting(false);
                    toast.error(response.data.message);
                }
            } catch (error) {
                setSubmitting(false);
                console.error("Error:", error);
                toast.error(error.response.data.message);
            }
        }

    })

    const handleCourseChange = (e) => {
        const id = e.target.value
        groupformik.setFieldValue('batch_id', '')
        if (id == '') {
            dispatch(getTutorMyCourseBatchListData('0'))
        }
        else {
            dispatch(getTutorMyCourseBatchListData(id))
        }
    }

    return (
        <div>

            <section className="after-header">
                {/* Breadcrum Start */}
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb bg-light">
                        <li className="breadcrumb-item  ps-5" aria-current="page">
                            <Link to="javascript:history.back()">
                                <i className="fa-solid fa-chevron-left text-dark" />
                            </Link>
                            &nbsp;&nbsp;My Assessments
                        </li>
                    </ol>
                </nav>
                {/* Breadcrum End */}
                <div className="main-container-sec">
                    <div className="row mx-0">
                        <div className="col-lg-3">
                            <TutorSidebar />
                        </div>
                        <div className="col-lg-9">
                            <main className="px-3 py-4">
                                <div className="study-material">
                                    <div className="row study-material-card-sec">
                                        <div className="col-lg-4 col-md-6 mb-3">
                                            {/* Add Objective Test card */}
                                            <div className="card" id="add-study-tab">
                                                <div className="card-body">
                                                    <div className="row">
                                                        <div className="col-lg-3 col-md-3 col-3">
                                                            <div className="icon-sec">
                                                                <i className="bi bi-file-earmark-richtext" />
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-9 col-md-9 col-9">
                                                            <h5 className="mb-0">Add Objective Test</h5>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        {/* Add Subjective Test card */}
                                        <div className="col-lg-4 col-md-6 mb-3">
                                            <div className="card" id="view-study-tab">
                                                <Link to="/tutor/add-subjective-assessment">
                                                    <div className="card-body">
                                                        <div className="row">
                                                            <div className="col-lg-3 col-md-3 col-3">
                                                                <div className="icon-sec">
                                                                    <i className="bi bi-file-earmark-richtext" />
                                                                </div>
                                                            </div>
                                                            <div className="col-lg-9 col-md-9 col-9">
                                                                <h5 className="mb-0">Add Subjective Test</h5>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                    {/* Add Objective Test Start section */}
                                    <div
                                        className="add-study-material-sec mt-5"
                                        id="add-study-tab-pane"

                                    >
                                        <ul className="nav nav-tabs my-student-nav-sec" id="myTab" role="tablist">
                                            <li className="nav-item" role="presentation">
                                                <button
                                                    className="nav-link active"
                                                    id="obj-one-to-one-tab"
                                                    data-bs-toggle="tab"
                                                    data-bs-target="#obj-one-to-one"
                                                    type="button"
                                                    role="tab"
                                                    aria-controls="home"
                                                    aria-selected="true"
                                                >
                                                    One To One
                                                </button>
                                            </li>
                                            <li className="nav-item" role="presentation">
                                                <button
                                                    className="nav-link"
                                                    id="obj-group-tab"
                                                    data-bs-toggle="tab"
                                                    data-bs-target="#obj-group"
                                                    type="button"
                                                    role="tab"
                                                    aria-controls="profile"
                                                    aria-selected="false"
                                                >
                                                    Group Tutoring
                                                </button>
                                            </li>
                                        </ul>
                                        <div className="tab-content my-student-tab-pane" id="myTabContent">
                                            <div
                                                className="tab-pane fade show active"
                                                id="obj-one-to-one"
                                                role="tabpanel"
                                                aria-labelledby="obj-one-to-one-tab"
                                            >
                                                <form onSubmit={oneformik.handleSubmit}>
                                                    <div className="row my-4">

                                                        <div className="col-lg-4 col-md-6">
                                                            <label htmlFor="" className="label">
                                                                Select Course
                                                            </label>
                                                            <br />
                                                            <select className="select-form w-100 rounded"
                                                                name="course_id"
                                                                onChange={(e) => {
                                                                    oneformik.handleChange(e);
                                                                    handleCourseChange(e);
                                                                }}
                                                                onBlur={oneformik.handleBlur}
                                                                value={oneformik.values.course_id}>
                                                                <option value="">-Select-</option>
                                                                {
                                                                    TutorMyCourseOneListApiData?.map((data) => (
                                                                        <option value={`${data?.id}`}>{data?.name}</option>
                                                                    ))}
                                                            </select>
                                                            <div className="help-block with-errors">
                                                                {oneformik.touched.course_id && oneformik.errors.course_id ? (
                                                                    <div className='text-danger'>{oneformik.errors.course_id}</div>
                                                                ) : null}
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-4 col-md-6">
                                                            <label htmlFor="" className="label">
                                                                Assessment name
                                                            </label>
                                                            <br />
                                                            <input
                                                                maxLength={100}
                                                                type="text"
                                                                className="input-card-form w-100 rounded"
                                                                placeholder="Enter assessment name"
                                                                name="assesment_name"
                                                                onChange={oneformik.handleChange}
                                                                onBlur={oneformik.handleBlur}
                                                                value={oneformik.values.assesment_name}
                                                            />
                                                            <div className="help-block with-errors">
                                                                {oneformik.touched.assesment_name && oneformik.errors.assesment_name ? (
                                                                    <div className='text-danger'>{oneformik.errors.assesment_name}</div>
                                                                ) : null}
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-4 col-md-6">
                                                            <label htmlFor="" className="label">
                                                                No. of Questions
                                                            </label>
                                                            <br />
                                                            <input

                                                                maxLength={4}
                                                                type="number"
                                                                className="input-card-form w-100 rounded"
                                                                placeholder={0}
                                                                name="no_of_question"
                                                                onChange={oneformik.handleChange}
                                                                onBlur={oneformik.handleBlur}
                                                                value={oneformik.values.no_of_question}
                                                            />
                                                            <div className="help-block with-errors">
                                                                {oneformik.touched.no_of_question && oneformik.errors.no_of_question ? (
                                                                    <div className='text-danger'>{oneformik.errors.no_of_question}</div>
                                                                ) : null}
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-4 col-md-6">
                                                            <label htmlFor="" className="label">
                                                                Total Marks
                                                            </label>
                                                            <br />
                                                            <input
                                                                maxLength={4}
                                                                type="number"
                                                                className="input-card-form w-100 rounded"
                                                                placeholder="Total Marks"
                                                                name="total_marks"
                                                                onChange={oneformik.handleChange}
                                                                onBlur={oneformik.handleBlur}
                                                                value={oneformik.values.total_marks}
                                                            />
                                                            <div className="help-block with-errors">
                                                                {oneformik.touched.total_marks && oneformik.errors.total_marks ? (
                                                                    <div className='text-danger'>{oneformik.errors.total_marks}</div>
                                                                ) : null}
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-4 col-md-6">
                                                            <label htmlFor="" className="label">
                                                                Duration(In Min)
                                                            </label>
                                                            <br />
                                                            <input
                                                                min={1}
                                                                maxLength={10}
                                                                type="number"
                                                                className="input-card-form w-100 rounded"
                                                                placeholder="Duration"
                                                                name="duration"
                                                                onChange={oneformik.handleChange}
                                                                onBlur={oneformik.handleBlur}
                                                                value={oneformik.values.duration}
                                                            />
                                                            <div className="help-block with-errors">
                                                                {oneformik.touched.duration && oneformik.errors.duration ? (
                                                                    <div className='text-danger'>{oneformik.errors.duration}</div>
                                                                ) : null}
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-4 col-md-6">
                                                            <label htmlFor="" className="label">
                                                                Start Date
                                                            </label>
                                                            <br />
                                                            <input
                                                                 min={todayLocal}
                                                                type="date"
                                                                className="input-card-form w-100 rounded"
                                                                placeholder="Enter material name"
                                                                name="assesment_date"
                                                                onChange={oneformik.handleChange}
                                                                onBlur={oneformik.handleBlur}
                                                                value={oneformik.values.assesment_date}
                                                            />
                                                            <div className="help-block with-errors">
                                                                {oneformik.touched.assesment_date && oneformik.errors.assesment_date ? (
                                                                    <div className='text-danger'>{oneformik.errors.assesment_date}</div>
                                                                ) : null}
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-4 col-md-6">
                                                            <label htmlFor="" className="label">
                                                                End Date
                                                            </label>
                                                            <br />
                                                            <input
                                                                 min={todayLocal}
                                                                type="date"
                                                                className="input-card-form w-100 rounded"
                                                                placeholder="Enter material name"
                                                                name="submit_date"
                                                                onChange={oneformik.handleChange}
                                                                onBlur={oneformik.handleBlur}
                                                                value={oneformik.values.submit_date}
                                                            />
                                                            <div className="help-block with-errors">
                                                                {oneformik.touched.submit_date && oneformik.errors.submit_date ? (
                                                                    <div className='text-danger'>{oneformik.errors.submit_date}</div>
                                                                ) : null}
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-2">

                                                            <input
                                                                disabled={oneformik.isSubmitting}
                                                                type="submit"
                                                                defaultValue={oneformik.isSubmitting ? <HourglassLoader /> : 'Submit'}
                                                                className="btn btn-primary srch-btn w-100"
                                                            />
                                                            {/* <button
                                                                type="submit"
                                                                disabled={oneformik.isSubmitting}
                                                                className="btn btn-primary srch-btn w-100"
                                                            >
                                                                {oneformik.isSubmitting ? <HourglassLoader /> : 'Submit'}
                                                            </button> */}

                                                        </div>

                                                    </div>
                                                </form>
                                            </div>
                                            <div
                                                className="tab-pane fade"
                                                id="obj-group"
                                                role="tabpanel"
                                                aria-labelledby="obj-group-tab"
                                            >

                                                <form onSubmit={groupformik.handleSubmit}>
                                                    <div className="row my-4">
                                                        <div className="col-lg-4 col-md-6">
                                                            <label htmlFor="" className="label">
                                                                Select Course
                                                            </label>
                                                            <br />
                                                            <select className="select-form w-100 rounded"
                                                                name="course_id"
                                                                onChange={(e) => {
                                                                    groupformik.handleChange(e);
                                                                    handleCourseChange(e);
                                                                }}
                                                                onBlur={groupformik.handleBlur}
                                                                value={groupformik.values.course_id}>
                                                                <option value="">-Select-</option>
                                                                {
                                                                    TutorMyCourseGroupListApiData?.map((data) => (
                                                                        <option value={`${data?.id}`}>{data?.name}</option>
                                                                    ))}
                                                            </select>
                                                            <div className="help-block with-errors">
                                                                {groupformik.touched.course_id && groupformik.errors.course_id ? (
                                                                    <div className='text-danger'>{groupformik.errors.course_id}</div>
                                                                ) : null}
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-4 col-md-6">
                                                            <label htmlFor="" className="label">
                                                                Select Batch
                                                            </label>
                                                            <br />
                                                            <select className="select-form w-100 rounded" name="batch_id"
                                                                onChange={groupformik.handleChange}
                                                                onBlur={groupformik.handleBlur}
                                                                value={groupformik.values.batch_id}>
                                                                <option value="">-Select-</option>
                                                                {
                                                                    TutorMyCourseGroupBatchListApiData?.map((data) => (
                                                                        <option value={`${data?.id}`}>{data?.batch_name}</option>
                                                                    ))}
                                                            </select>
                                                            <div className="help-block with-errors">
                                                                {groupformik.touched.batch_id && groupformik.errors.batch_id ? (
                                                                    <div className='text-danger'>{groupformik.errors.batch_id}</div>
                                                                ) : null}
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-4 col-md-6">
                                                            <label htmlFor="" className="label">
                                                                Assessment name
                                                            </label>
                                                            <br />
                                                            <input
                                                                maxLength={100}
                                                                type="text"
                                                                className="input-card-form w-100 rounded"
                                                                placeholder="Enter assessment name"
                                                                name="assesment_name"
                                                                onChange={groupformik.handleChange}
                                                                onBlur={groupformik.handleBlur}
                                                                value={groupformik.values.assesment_name}
                                                            />
                                                            <div className="help-block with-errors">
                                                                {groupformik.touched.assesment_name && groupformik.errors.assesment_name ? (
                                                                    <div className='text-danger'>{groupformik.errors.assesment_name}</div>
                                                                ) : null}
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-4 col-md-6">
                                                            <label htmlFor="" className="label">
                                                                No. of Questions
                                                            </label>
                                                            <br />
                                                            <input
                                                                min={1}
                                                                maxLength={4}
                                                                type="number"
                                                                className="input-card-form w-100 rounded"
                                                                placeholder={0}
                                                                name="no_of_question"
                                                                onChange={groupformik.handleChange}
                                                                onBlur={groupformik.handleBlur}
                                                                value={groupformik.values.no_of_question}
                                                            />
                                                            <div className="help-block with-errors">
                                                                {groupformik.touched.no_of_question && groupformik.errors.no_of_question ? (
                                                                    <div className='text-danger'>{groupformik.errors.no_of_question}</div>
                                                                ) : null}
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-4 col-md-6">
                                                            <label htmlFor="" className="label">
                                                                Total Marks
                                                            </label>
                                                            <br />
                                                            <input
                                                                min={1}
                                                                maxLength={3}
                                                                type="number"
                                                                className="input-card-form w-100 rounded"
                                                                placeholder="Total Marks"
                                                                name="total_marks"
                                                                onChange={groupformik.handleChange}
                                                                onBlur={groupformik.handleBlur}
                                                                value={groupformik.values.total_marks}
                                                            />
                                                            <div className="help-block with-errors">
                                                                {groupformik.touched.total_marks && groupformik.errors.total_marks ? (
                                                                    <div className='text-danger'>{groupformik.errors.total_marks}</div>
                                                                ) : null}
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-4 col-md-6">
                                                            <label htmlFor="" className="label">
                                                                Duration(In Min)
                                                            </label>
                                                            <br />
                                                            <input
                                                                min={1}
                                                                maxLength={10}
                                                                type="number"
                                                                className="input-card-form w-100 rounded"
                                                                placeholder="Duration"
                                                                name="duration"
                                                                onChange={groupformik.handleChange}
                                                                onBlur={groupformik.handleBlur}
                                                                value={groupformik.values.duration}
                                                            />
                                                            <div className="help-block with-errors">
                                                                {groupformik.touched.duration && groupformik.errors.duration ? (
                                                                    <div className='text-danger'>{groupformik.errors.duration}</div>
                                                                ) : null}
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-4 col-md-6">
                                                            <label htmlFor="" className="label">
                                                                Start Date
                                                            </label>
                                                            <br />
                                                            <input
                                                                 min={todayLocal}
                                                                type="date"
                                                                className="input-card-form w-100 rounded"
                                                                placeholder="Enter material name"
                                                                name="assesment_date"
                                                                onChange={groupformik.handleChange}
                                                                onBlur={groupformik.handleBlur}
                                                                value={groupformik.values.assesment_date}
                                                            />
                                                            <div className="help-block with-errors">
                                                                {groupformik.touched.assesment_date && groupformik.errors.assesment_date ? (
                                                                    <div className='text-danger'>{groupformik.errors.assesment_date}</div>
                                                                ) : null}
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-4 col-md-6">
                                                            <label htmlFor="" className="label">
                                                                End Date
                                                            </label>
                                                            <br />
                                                            <input
                                                                 min={todayLocal}
                                                                type="date"
                                                                className="input-card-form w-100 rounded"
                                                                placeholder="Enter material name"
                                                                name="submit_date"
                                                                onChange={groupformik.handleChange}
                                                                onBlur={groupformik.handleBlur}
                                                                value={groupformik.values.submit_date}
                                                            />
                                                            <div className="help-block with-errors">
                                                                {groupformik.touched.submit_date && groupformik.errors.submit_date ? (
                                                                    <div className='text-danger'>{groupformik.errors.submit_date}</div>
                                                                ) : null}
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-2">

                                                            <input
                                                                disabled={groupformik.isSubmitting}
                                                                type="submit"
                                                                defaultValue="Next"
                                                                className="btn btn-primary srch-btn w-100"
                                                            />

                                                        </div>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                    {/* Add Objective Test End section */}

                                </div>
                            </main>

                        </div>
                    </div>
                </div>
            </section>

        </div>
    )
}

export default TutorAddObjectiveAssessment